import { PLAGIARISM } from '@src/components/Cards/constants'
import { PlagiarismCardBody } from '@src/components/Cards/PlagiarismCard'
import { NOOP_PLAG_CARD } from '@src/utils/dataTestIds'
import noop from '@src/utils/noop'
import * as React from 'react'
import * as Styled from './styled'

const NoopBlurredPlagiarismCard: React.FunctionComponent<{}> = ({ children }) => (
  <Styled.CardContainer>
    <Styled.CardContent
      className="focused"
      isNewOrRead={true}
      cardState="new"
      focused={true}
      data-test={NOOP_PLAG_CARD}
    >
      <Styled.InnerContent>
        <PlagiarismCardBody
          errorText="We found this text in our plagiarism check"
          message=""
          replacements={[]}
          setSelectedReplacement={noop}
          type={PLAGIARISM}
          rule=""
        />
      </Styled.InnerContent>
    </Styled.CardContent>
    <Styled.Blur />
    {children}
  </Styled.CardContainer>
)

export default NoopBlurredPlagiarismCard



// WEBPACK FOOTER //
// ./src/components/PlagiarismLock/NoopBlurredPlagiarismCard.tsx